import React from "react";
import { useForm } from "react-hook-form";
import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import { datePickerIcon, closeIcon } from "../../../assetData/icons";
import CustomDateInput from "../../../components/ui/custom-date-input/CustomDateInput";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";

const MasterRoleAdd = ({ buttonConfig, isButtonClicked }) => {
  const addHandler = buttonConfig.addHandler;

  const closeHandler = buttonConfig.closeAddModal;

  const schema = z.object({
    security_type: z.string().nonempty(),
    short_name: z.string().nonempty(),
    asset_class: z.string().nonempty(),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nullable(),
  });

  const form = useForm({
    defaultValues: {
      status: "true",
      // short_name: "-",
      eff_end_date: null,
    },
    resolver: zodResolver(schema),
  });

  const errors = form.formState.errors;
  form.watch();

  const onSubmit = async (data) => {
    const statusValue = form.getValues("status") === "true";
    const updatedData = { ...data, status: statusValue };
    const res = await addHandler(updatedData);
    if (res) closeHandler();
  };

  const onClose = () => {
    closeHandler();
  };

  return (
    <>
      <div className="fixed left-1/2 z-50 mx-auto min-h-[300px] w-[98%] max-w-[1000px] -translate-x-1/2 rounded bg-white p-8 max-lg:top-[30%] max-sm:top-[10%] lg:top-1/2 lg:-translate-y-1/2">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">
          Add Security Type
        </h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="scrollbar-custom w-full overflow-x-hidden overflow-y-scroll pr-2 max-lg:max-h-[550px] lg:max-h-[400px] ">
            {/* row 1 */}
            <div className="gap-2 sm:flex">
              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">
                  Security Type Name *
                </label>
                <input
                  placeholder="Type here"
                  {...form.register("security_type")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.security_type && "border-[1px] border-red-300",
                  )}
                />
              </div>

              <div className={cn("flex w-full flex-col gap-2  max-sm:mt-4")}>
                <label className="text-base text-[#636363]">Short Name *</label>
                <input
                  placeholder="Type here"
                  {...form.register("short_name")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.short_name && "border-[1px] border-red-300",
                  )}
                />
              </div>

              <div className="flex h-full w-full flex-col gap-2 max-sm:mt-4">
                <label className="text-[#636363]">Asset Class</label>
                <div
                  className={cn(
                    " h-full rounded bg-neutral-100 px-2 py-[9px]",
                    errors.asset_class && "border-[1px] border-red-300",
                  )}
                >
                  <select
                    {...form.register("asset_class")}
                    className=" w-full  bg-transparent px-2 text-[#636363] focus:outline-none"
                    defaultValue="equity"
                  >
                    <option value="equity">Equity</option>
                    <option value="hybrid">Hybrid</option>
                    <option value="mf">MF</option>
                    <option value="non-equity">Non-Equity</option>
                    <option value="Unlisted">Unlisted</option>
                  </select>
                </div>
              </div>
            </div>

            {/* row 2 */}

            <div className="items-end gap-2 sm:flex ">
              <div className="flex h-full w-full flex-col gap-2 max-sm:mt-4">
                <label className="text-[#636363]">Status</label>
                <div
                  className={cn(
                    " h-full rounded bg-neutral-100 px-2 py-[9px]",
                    errors.status && "border-[1px] border-red-300",
                  )}
                >
                  <select
                    {...form.register("status")}
                    className=" w-full  bg-transparent px-2 text-[#636363] focus:outline-none"
                    defaultValue={true}
                  >
                    <option value={true}>Active</option>
                    <option value={false}>Inactive</option>
                  </select>
                </div>
              </div>

              <div className="mt-8 flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                <div className="flex w-full  flex-col gap-2 ">
                  <label>Start date *</label>

                  <div className="relative flex w-full">
                    <CustomDateInput
                      handleSetValue={(val) =>
                        form.setValue("eff_start_date", val)
                      }
                      value={form.getValues("eff_start_date")}
                      className1="w-full"
                      className={"w-full"}
                    />
                  </div>
                </div>
              </div>

              <div className="mt-8 flex w-full items-stretch  gap-4 text-neutral-600 max-sm:mt-4">
                <div className="flex w-full  flex-col gap-2 ">
                  <label>End date</label>

                  <div className="relative flex w-full">
                    <CustomDateInput
                      handleSetValue={(val) =>
                        form.setValue("eff_end_date", val)
                      }
                      value={form.getValues("eff_start_date")}
                      // {...form.register("eff_end_date")}
                      min={form.getValues("eff_start_date")}
                      className1="w-full"
                      className={"w-full"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-end justify-between gap-2 sm:[&>button]:w-1/3">
            <button
              type="submit"
              disabled={isButtonClicked}
              className={` ${
                isButtonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-16 py-2 font-semibold text-white `}
            >
              {isButtonClicked ? <MirageLoader /> : "ADD"}
            </button>
            <button className="max-lg:hidden"></button>
            <button className="max-lg:hidden"></button>
          </div>
        </form>
      </div>
      <BackDrop />
    </>
  );
};

export default MasterRoleAdd;
